import React, { FC, useEffect } from 'react'
import { HeartIcon, SearchIcon, ChevronDownIcon } from '@heroicons/react/outline'
import { CAPTION_CATEGORY_LIST } from '../IssueView'
import useCaptions from '../../redux/caption-library/useCaptions'
import { Bubble, LineInput, FilterGroup } from '../System'
import { StyledCaptionLibraryHeader } from '.'
import useSearchParams from '../utils/useSearchParams'

const CaptionLibraryHeader: FC = () => {
  const {
    search,
    categories,
    onlyFavorites,
    sort,
    hideUsed,
    actions: {
      searchCaptions,
      changeCategories,
      changeFavorites,
      changeSort,
      changeHideUsed,
      loadSearch
    }
  } = useCaptions()

  const { getSearchFromURL } = useSearchParams({
    search,
    categories,
    onlyFavorites,
    sort,
    hideUsed
  })

  useEffect(() => {
    loadSearch(getSearchFromURL())
  }, [])

  return (
    <StyledCaptionLibraryHeader>
      <div className="page-header-top">
        <LineInput
          icon={<SearchIcon />}
          value={search}
          placeholder="Search Captions"
          clearInput={() => searchCaptions('')}
          onChange={(value) => searchCaptions(value)}
          debounce={500}
          className="page-header-search-input"
        />
        <label className="page-header-action dropdown">
          <select value={sort} onChange={(e) => changeSort(e.target.value)}>
            <option value="newest">Recently Added</option>
            <option value="suggested">Suggested</option>
          </select>
          <ChevronDownIcon />
        </label>
      </div>
      <div className="page-header-categories">
        <Bubble onClick={() => changeFavorites(!onlyFavorites)} isActive={onlyFavorites} noMargin>
          <HeartIcon />
        </Bubble>
        <Bubble onClick={() => changeHideUsed(!hideUsed)} isActive={hideUsed} noMargin>
          Hide Used
        </Bubble>
        <FilterGroup
          filters={[...CAPTION_CATEGORY_LIST]}
          activeFilters={categories}
          onFilter={(filter) => changeCategories(filter)}
        />
      </div>
    </StyledCaptionLibraryHeader>
  )
}

export default CaptionLibraryHeader
